import React, { useState, useEffect } from 'react';
import { useLanguage } from '../contexts/LanguageContext';
import { Link } from 'react-router-dom';
import PageBanner from '../components/PageBanner/PageBanner';
// import LogoSlider from '../components/LogoSlider/LogoSlider';
import brownGirl from '../assets/images/browngirl.avif';
// import banner1 from "../assets/images/banner1.jpg";
// import banner2 from "../assets/images/banner2.jpg";
// import banner3 from "../assets/images/banner3.jpg";
// import banner4 from "../assets/images/banner5.jpg";
import banner01 from "../assets/images/banner01.jpeg";
import banner02 from "../assets/images/banner02.jpeg"
import banner03 from "../assets/images/banner03.jpeg"
import banner04 from "../assets/images/banner04.jpeg"
// import banner5 from "../assets/images/banner6.jpg";
import blackyoga from '../assets/images/blackyoga.jpg';
import story from '../assets/images/y1.jpg';
import yoga3 from "../assets/images/y3.jpg";
import yoga4 from "../assets/images/homenew.jpeg";
import yoga5 from "../assets/images/y5.jpg";
import yoga10 from "../assets/images/studio.jpeg";
import m1 from "../assets/images/m1.jpg";
import m2 from "../assets/images/m2.jpg";
import m5 from "../assets/images/m5.jpg";
import e1 from "../assets/images/pregnency.png";
import e2 from "../assets/images/e2.webp";
import e3 from "../assets/images/e3.jpg";
// import vinyasa from "../assets/images/Vinyasa.jpg";
// import ashtanga from "../assets/images/Ashtanga.jpg";
// import iyengar from "../assets/images/Iyengar Yoga.jpg";
// import kundalini from "../assets/images/Kundalini Yoga.jpg";
// import bikram from "../assets/images/Bikram Yoga.jpg";
// import hatha from "../assets/images/hatha.jpg";
import india from "../assets/images/indai.webp";
// import teacher from "../assets/images/teacherimg.png";
// import student from "../assets/images/student.png";
// import heat from "../assets/images/heat.png";
// import power from "../assets/images/power.png";
import pregnancy from "../assets/images/corporateyoga.png";
// import raj from "../assets/images/raj.png";
import urja from "../assets/images/pregyoga.jpeg";
// import man1 from "../assets/images/man1.jpg";
// import man2 from "../assets/images/man2.jpg";
// import man3 from "../assets/images/man3.jpg";
import student1 from "../assets/images/oip.webp";
import teach from "../assets/images/teac.jpg";
import verified from "../assets/images/done.webp";

import './Home.css';
import TestimonialSlider from '../components/TestimonialSlider/TestimonialSlider';




function Home() {
  const { t } = useLanguage();
  // State for Back to Top button visibility
  // const [isVisible, setIsVisible] = useState(false);

  // State for testimonial slider
  // const [currentTestimonial, setCurrentTestimonial] = useState(0);

  // Testimonials data
  const testimonials = [
    {
      id: 1,
      name: 'Priya Sharma',
      role: 'Yoga Enthusiast',
      content: 'Yoga Karega India has completely transformed my life! The instructors are amazing and truly care about each student\'s progress.',
      rating: 5
    },
    {
      id: 2,
      name: 'Rahul Verma',
      role: 'Regular Practitioner',
      content: 'The best yoga experience I\'ve ever had! I\'ve seen incredible improvements in my flexibility and mental clarity.',
      rating: 5
    },
    {
      id: 3,
      name: 'Ananya Patel',
      role: 'Yoga Teacher',
      content: 'Amazing instructors and a welcoming community. I can see a huge difference in my flexibility and mental peace.',
      rating: 5
    },
    {
      id: 4,
      name: 'Vikram Mehta',
      role: 'Online Student',
      content: 'The online classes are just as effective as in-person sessions. The teachers are very attentive and provide individual attention.',
      rating: 5
    },
    {
      id: 5,
      name: 'Neha Gupta',
      role: 'Yoga Teacher Trainee',
      content: 'The perfect balance of traditional yoga and modern teaching methods. None compare to the quality of instruction here.',
      rating: 5
    }
  ];

  // Show/hide Back to Top button based on scroll position
  // Show/hide Back to Top button based on scroll position
  // useEffect(() => {
  //   const toggleVisibility = () => {
  //     if (window.scrollY > 300) {
  //       setIsVisible(true);
  //     } else {
  //       setIsVisible(false);
  //     }
  //   };

  //   window.addEventListener('scroll', toggleVisibility);
  //   return () => window.removeEventListener('scroll', toggleVisibility);
  // }, []);

  // Auto-rotate testimonials
  // Auto-rotate testimonials
  // useEffect(() => {
  //   const timer = setInterval(() => {
  //     setCurrentTestimonial((prev) => (prev === testimonials.length - 1 ? 0 : prev + 1));
  //   }, 5000);
  //   return () => clearInterval(timer);
  // }, [testimonials.length]);

  // Handle manual navigation
  // const goToTestimonial = (index) => {
  //   setCurrentTestimonial(index);
  // };

  // Render star rating
  // const renderStars = (rating) => {
  //   return Array(5).fill(0).map((_, i) => (
  //     <span key={i} className={i < rating ? 'star filled' : 'star'}>
  //       {i < rating ? '★' : '☆'}
  //     </span>
  //   ));
  // };


  // Cursor effect removed

  const features = [
    {
      id: 1,
      icon: '🎓',
      title: t('home.why_choose.training'),
      description: t('home.why_choose.training_desc')
    },
    {
      id: 2,
      icon: '🛡️',
      title: t('home.why_choose.safety'),
      description: t('home.why_choose.safety_desc')
    },
    // {
    //   id: 3,
    //   icon: '🏋️',
    //   title: 'Equipment',
    //   description: 'Premium yoga mats, blocks, straps, and props available for all students.'
    // },
    {
      id: 4,
      icon: '👥',
      title: t('home.why_choose.community'),
      description: t('home.why_choose.community_desc')
    }
  ];

  // const heroText = "Yoga At Your Home ";

  const [faqOpenState, setFaqOpenState] = useState({});

  const toggleFaq = (id) => {
    setFaqOpenState(prev => ({
      ...prev,
      [id]: !prev[id]
    }));
  };

  const faqList = [1, 2, 3, 4, 5, 6];

  return (
    <div className="home">

      <PageBanner
        hideOverlay={true}
        className={{}}
        pageKey="home"
        sliderImages={[banner01, banner02, banner04, banner03]}

      />

      {/* All States Section - Yoga Teachers Availability */}
      <section className="all-states-section" style={{ backgroundColor: '#fff', padding: '0', overflow: 'hidden' }}>
        <div className="container">
          <div className="section-header" data-aos="fade-up">
            <span className="section-tag" style={{ background: '#fff0e6', color: '#ff6b35' }}>{t('home.presence.tag')}</span>
            <h2 className="section-title">{t('home.presence.title')} <span className="highlight" style={{ color: '#ff6b35' }}>{t('home.presence.highlight')}</span></h2>
            <div className="divider"></div>
            <p className="section-subtitle">{t('home.presence.subtitle')}</p>
          </div>

          {/* Auto-scrolling stats container */}
          <div className="stats-scroll-wrapper">
            <div className="stats-scroll-track">
              {/* First set of cards */}
              <div className="stat-card" style={{ backgroundImage: `url(${india})`, backgroundSize: 'cover', backgroundPosition: 'center' }}>
                <div className="stat-overlay"></div>
                <h3 style={{ color: "#fff", position: 'relative', zIndex: 2 }}>{t('home.stats.states')}</h3>
                <p style={{ position: 'relative', zIndex: 2 }}>{t('home.stats.states_desc')}</p>
              </div>

              <div className="stat-card" style={{ backgroundImage: `url(${teach})`, backgroundSize: 'cover', backgroundPosition: 'center' }}>
                <div className="stat-overlay"></div>
                <h3 style={{ position: 'relative', zIndex: 2 }}>{t('home.stats.teachers')}</h3>
                <p style={{ position: 'relative', zIndex: 2 }}>{t('home.stats.teachers_desc')}</p>
              </div>

              <div className="stat-card" style={{ backgroundImage: `url(${student1})`, backgroundSize: 'cover', backgroundPosition: 'center' }}>
                <div className="stat-overlay"></div>
                <h3 style={{ position: 'relative', zIndex: 2 }}>{t('home.stats.students')}</h3>
                <p style={{ position: 'relative', zIndex: 2 }}>{t('home.stats.students_desc')}</p>
              </div>

              <div className="stat-card" style={{ backgroundImage: `url(${verified})`, backgroundSize: 'cover', backgroundPosition: 'center' }}>
                <div className="stat-overlay"></div>
                <h3 style={{ position: 'relative', zIndex: 2 }}>{t('home.stats.verified')}</h3>
                <p style={{ position: 'relative', zIndex: 2 }}>{t('home.stats.verified_desc')}</p>
              </div>

              {/* Duplicate set for infinite scroll */}
              <div className="stat-card" style={{ backgroundImage: `url(${india})`, backgroundSize: 'cover', backgroundPosition: 'center' }}>
                <div className="stat-overlay"></div>
                <h3 style={{ color: "#fff", position: 'relative', zIndex: 2 }}>{t('home.stats.states')}</h3>
                <p style={{ position: 'relative', zIndex: 2 }}>{t('home.stats.states_desc')}</p>
              </div>

              <div className="stat-card" style={{ backgroundImage: `url(${teach})`, backgroundSize: 'cover', backgroundPosition: 'center' }}>
                <div className="stat-overlay"></div>
                <h3 style={{ position: 'relative', zIndex: 2 }}>{t('home.stats.teachers')}</h3>
                <p style={{ position: 'relative', zIndex: 2 }}>{t('home.stats.teachers_desc')}</p>
              </div>

              <div className="stat-card" style={{ backgroundImage: `url(${student1})`, backgroundSize: 'cover', backgroundPosition: 'center' }}>
                <div className="stat-overlay"></div>
                <h3 style={{ position: 'relative', zIndex: 2 }}>{t('home.stats.students')}</h3>
                <p style={{ position: 'relative', zIndex: 2 }}>{t('home.stats.students_desc')}</p>
              </div>

              <div className="stat-card" style={{ backgroundImage: `url(${verified})`, backgroundSize: 'cover', backgroundPosition: 'center' }}>
                <div className="stat-overlay"></div>
                <h3 style={{ position: 'relative', zIndex: 2 }}>{t('home.stats.verified')}</h3>
                <p style={{ position: 'relative', zIndex: 2 }}>{t('home.stats.verified_desc')}</p>
              </div>
            </div>
          </div>
        </div>

      </section >





      {/* Trainers Section */}
      {/* < section className="trainers-section" >
        <div className="container">
          <div className="section-header" data-aos="fade-up">
            <span className="section-tag">Expert Team</span>
            <h2 className="section-title">Meet Our Certified <span className="highlight">Yoga Teachers</span></h2>
            <div className="divider"></div>
          </div>

          <div className="trainers-grid"> */}
      {/* Trainer 1 - Agra */}
      {/* <div className="trainer-card" data-aos="fade-up" data-aos-delay="100">
              <div className="trainer-image-wrapper">
                <img
                  src={man1}
                  alt="Trainer - Hatha Yoga"
                  className="trainer-image"
                  onError={(e) => {
                    e.target.src = 'https://randomuser.me/api/portraits/women/45.jpg';
                  }}
                />
                <div className="trainer-badge">Featured</div>
              </div>
              <div className="trainer-info">
                <h3 className="trainer-name" style={{ fontSize: '30px' }}>Mukesh Kumar</h3>
                <p className="trainer-specialization"> Yoga Specialist</p>
                <div className="trainer-meta"> */}
      {/* <span className="trainer-city">📍 Agra</span> */}
      {/* <span className="trainer-experience">5+ Years</span>
                </div>
                <Link to="/trainers?state=Uttar Pradesh&city=Agra" className="btn btn-primary btn-small">Join Training</Link>
              </div>
            </div> */}

      {/* <div className="trainer-card" data-aos="fade-up" data-aos-delay="100">
              <div className="trainer-image-wrapper">
                <img
                  src={man2}
                  alt="Trainer - Hatha Yoga"
                  className="trainer-image"
                  onError={(e) => {
                    e.target.src = 'https://randomuser.me/api/portraits/women/45.jpg';
                  }}
                />
                <div className="trainer-badge">Featured</div>
              </div>
              <div className="trainer-info">
                <h3 className="trainer-name" style={{ fontSize: '30px' }}>Rohan Kumar</h3>
                <p className="trainer-specialization"> Yoga Specialist</p>
                <div className="trainer-meta"> */}
      {/* <span className="trainer-city">📍 Agra</span> */}
      {/* <span className="trainer-experience">2+ Years</span>
                </div>
                <Link to="/trainers?state=Uttar Pradesh&city=Agra" className="btn btn-primary btn-small">Join Training</Link>
              </div>
            </div>

            <div className="trainer-card" data-aos="fade-up" data-aos-delay="100">
              <div className="trainer-image-wrapper">
                <img
                  src={man3}
                  alt="Trainer - Hatha Yoga"
                  className="trainer-image"
                  onError={(e) => {
                    e.target.src = 'https://randomuser.me/api/portraits/women/45.jpg';
                  }}
                />
                <div className="trainer-badge">Featured</div>
              </div>
              <div className="trainer-info">
                <h3 className="trainer-name" style={{ fontSize: '30px' }}>Rohit jain</h3>
                <p className="trainer-specialization"> Yoga Specialist</p>
                <div className="trainer-meta"> */}
      {/* <span className="trainer-city">📍 Agra</span> */}
      {/* <span className="trainer-experience">3+ Years</span>
                </div>
                <Link to="/trainers?state=Uttar Pradesh&city=Agra" className="btn btn-primary btn-small">Join Training</Link>
              </div>
            </div>




          </div>
        </div>
      </section > */}

      {/* 40 Days Training Highlight Section */}
      {/* < section className="training-highlight-section" >
        <div className="container">
          <div className="highlight-content">
            <div className="highlight-header" data-aos="fade-up">
              <h2>40 Days Yoga Teacher Training Program</h2>
              <p>Comprehensive professional yoga training certification</p>
            </div>

            <div className="highlight-features-grid">
              <div className="highlight-feature" data-aos="zoom-in" data-aos-delay="100">
                <div className="feature-icon-highlight">
                  <svg width="40" height="40" viewBox="0 0 40 40" fill="none">
                    <path d="M20 2C10.06 2 2 10.06 2 20s8.06 18 18 18 18-8.06 18-18S29.94 2 20 2zm0 32c-7.73 0-14-6.27-14-14S12.27 6 20 6s14 6.27 14 14-6.27 14-14 14z" fill="currentColor" />
                    <path d="M20.5 11h-1v10l8.6 5.2.7-1.1-8.3-5V11z" fill="currentColor" />
                  </svg>
                </div>
                <h3>Daily Practical Sessions</h3>
                <p>Hands-on yoga practice every day with expert guidance</p>
              </div>

              <div className="highlight-feature" data-aos="zoom-in" data-aos-delay="150">
                <div className="feature-icon-highlight">
                  <svg width="40" height="40" viewBox="0 0 40 40" fill="none">
                    <path d="M20 2C10.06 2 2 10.06 2 20s8.06 18 18 18 18-8.06 18-18S29.94 2 20 2zm0 32c-7.73 0-14-6.27-14-14S12.27 6 20 6s14 6.27 14 14-6.27 14-14 14z" fill="currentColor" />
                    <path d="M14 20c0-3.31 2.69-6 6-6s6 2.69 6 6-2.69 6-6 6-6-2.69-6-6zm8 0c0-1.1-.9-2-2-2s-2 .9-2 2 .9 2 2 2 2-.9 2-2z" fill="currentColor" />
                  </svg>
                </div>
                <h3>Asanas, Pranayama & Meditation</h3>
                <p>Master postures, breathing techniques & meditation</p>
              </div>

              <div className="highlight-feature" data-aos="zoom-in" data-aos-delay="200">
                <div className="feature-icon-highlight">
                  <svg width="40" height="40" viewBox="0 0 40 40" fill="none">
                    <path d="M20 2C10.06 2 2 10.06 2 20s8.06 18 18 18 18-8.06 18-18S29.94 2 20 2zm0 32c-7.73 0-14-6.27-14-14S12.27 6 20 6s14 6.27 14 14-6.27 14-14 14z" fill="currentColor" />
                    <path d="M15 18h10v-2H15v2zm0 4h10v-2H15v2z" fill="currentColor" />
                  </svg>
                </div>
                <h3>Teaching Methodology</h3>
                <p>Learn how to teach and guide students effectively</p>
              </div>

              <div className="highlight-feature" data-aos="zoom-in" data-aos-delay="250">
                <div className="feature-icon-highlight">
                  <svg width="40" height="40" viewBox="0 0 40 40" fill="none">
                    <path d="M20 2C10.06 2 2 10.06 2 20s8.06 18 18 18 18-8.06 18-18S29.94 2 20 2zm0 32c-7.73 0-14-6.27-14-14S12.27 6 20 6s14 6.27 14 14-6.27 14-14 14z" fill="currentColor" />
                    <path d="M26.7 14.5L17 24.2l-5.7-5.7-1.4 1.4L17 27l11.1-11.1-1.4-1.4z" fill="currentColor" />
                  </svg>
                </div>
                <h3>Certification After Completion</h3>
                <p>Get internationally recognized yoga teaching certificate</p>
              </div>

              <div className="highlight-feature" data-aos="zoom-in" data-aos-delay="300">
                <div className="feature-icon-highlight">
                  <svg width="40" height="40" viewBox="0 0 40 40" fill="none">
                    <path d="M20 2C10.06 2 2 10.06 2 20s8.06 18 18 18 18-8.06 18-18S29.94 2 20 2zm0 32c-7.73 0-14-6.27-14-14S12.27 6 20 6s14 6.27 14 14-6.27 14-14 14z" fill="currentColor" />
                    <path d="M14 20c0 3.31 2.69 6 6 6s6-2.69 6-6-2.69-6-6-6-6 2.69-6 6zm8 0c0 1.1-.9 2-2 2s-2-.9-2 2 .9 2 2 2 2-.9 2-2z" fill="currentColor" />
                  </svg>
                </div>
                <h3>Career & Teaching Guidance</h3>
                <p>Support for building your yoga teaching career</p>
              </div>

              <div className="highlight-feature" data-aos="zoom-in" data-aos-delay="350">
                <div className="feature-icon-highlight">
                  <svg width="40" height="40" viewBox="0 0 40 40" fill="none">
                    <path d="M20 2C10.06 2 2 10.06 2 20s8.06 18 18 18 18-8.06 18-18S29.94 2 20 2zm0 32c-7.73 0-14-6.27-14-14S12.27 6 20 6s14 6.27 14 14-6.27 14-14 14z" fill="currentColor" />
                    <path d="M20 10c-5.52 0-10 4.48-10 10s4.48 10 10 10 10-4.48 10-10-4.48-10-10-10zm0 18c-4.41 0-8-3.59-8-8s3.59-8 8-8 8 3.59 8 8-3.59 8-8 8z" fill="currentColor" />
                  </svg>
                </div>
                <h3>Small Batch Learning</h3>
                <p>Personalized attention with limited class size</p>
              </div>
            </div>

            <div className="highlight-cta" data-aos="fade-up">
              <Link to="/booking" className="btn btn-primary btn-large">
                Enroll for 40 Days Training
                <span className="btn-icon">→</span>
              </Link>
            </div>
          </div>
        </div>
      </section > */}




      {/* Yoga Types Section */}
      <section className="yoga-types-section">
        <div className="container">
          <div className="section-header" data-aos="fade-up">
            <span className="section-tag">{t('home.types.tag')}</span>
            <h2 className="section-title">Yoga <span className="highlight">Types</span></h2>
            <div className="divider"></div>
          </div>

          <div className="yoga-types-grid">
            <Link to="/service/yoga-at-your-home" className="yoga-type-card yoga-type-card--link">
              <div className="yoga-image-container">
                <img src={yoga4} alt="Yoga at Your Home" className="yoga-image" />
              </div>
              <h3 className="yoga-type-name">Yoga at Your Home</h3>
              <span className="yoga-card-read-more">Read More →</span>
            </Link>

            <Link to="/service/online-yoga" className="yoga-type-card yoga-type-card--link">
              <div className="yoga-image-container">
                <img src={yoga5} alt="Online Yoga" className="yoga-image" />
              </div>
              <h3 className="yoga-type-name">Online Yoga</h3>
              <span className="yoga-card-read-more">Read More →</span>
            </Link>

            <Link to="/service/yoga-studio" className="yoga-type-card yoga-type-card--link">
              <div className="yoga-image-container">
                <img src={yoga10} alt="Yoga Studio" className="yoga-image" />
              </div>
              <h3 className="yoga-type-name">Yoga Studio</h3>
              <span className="yoga-card-read-more">Read More →</span>
            </Link>

            <Link to="/service/corporate-yoga" className="yoga-type-card yoga-type-card--link">
              <div className="yoga-image-container">
                <img src={pregnancy} alt="Corporate Yoga" className="yoga-image" />
              </div>
              <h3 className="yoga-type-name">Corporate Yoga</h3>
              <span className="yoga-card-read-more">Read More →</span>
            </Link>

            <Link to="/service/pregnancy-yoga" className="yoga-type-card yoga-type-card--link">
              <div className="yoga-image-container">
                <img src={urja} alt="Pregnancy Yoga" className="yoga-image" />
              </div>
              <h3 className="yoga-type-name">Pregnancy Yoga</h3>
              <span className="yoga-card-read-more">Read More →</span>
            </Link>

            <Link to="/service/meditation-magic" className="yoga-type-card yoga-type-card--link">
              <div className="yoga-image-container">
                <img src={e1} alt="Meditation Magic" className="yoga-image" />
              </div>
              <h3 className="yoga-type-name">Meditation Magic</h3>
              <span className="yoga-card-read-more">Read More →</span>
            </Link>

            <Link to="/service/positive-instruction" className="yoga-type-card yoga-type-card--link">
              <div className="yoga-image-container">
                <img src={e2} alt="Positive Instruction" className="yoga-image" />
              </div>
              <h3 className="yoga-type-name">Positive Instruction</h3>
              <span className="yoga-card-read-more">Read More →</span>
            </Link>

            <Link to="/service/stress-relief" className="yoga-type-card yoga-type-card--link">
              <div className="yoga-image-container">
                <img src={e3} alt="Stress Relief" className="yoga-image" />
              </div>
              <h3 className="yoga-type-name">Stress Relief</h3>
              <span className="yoga-card-read-more">Read More →</span>
            </Link>
          </div>
        </div>
      </section>
      {/* Enhanced Why Choose Us Section */}
      <section className="why-choose-us">
        <div className="container">
          <div className="section-header" data-aos="fade-up">
            <span className="section-tag">{t('home.why_choose.tag')}</span>
            <h2 className="section-title">{t('home.why_choose.title')} <span className="highlight">{t('home.why_choose.highlight')}</span></h2>
            <div className="divider"></div>
            <p className="section-subtitle">{t('home.why_choose.subtitle')}</p>
          </div>

          <div className="features-container">
            <div className="features-grid">
              {features.map((feature, index) => (
                <div
                  key={feature.id}
                  className="feature-card"
                  data-aos="fade-up"
                  data-aos-delay={index * 100}
                >
                  <div className="feature-card-inner">
                    <div className="feature-icon">
                      <div className="feature-icon-bg"></div>
                      <img
                        src={feature.id === 1 ? yoga4 : feature.id === 2 ? e2 : feature.id === 4 ? m2 : yoga5}
                        alt={feature.title}
                        className="feature-icon-img"
                      />
                    </div>
                    <h3 className="feature-title">{feature.title}</h3>
                    <p className="feature-description">{feature.description}</p>
                    <div className="feature-hover-content">
                      {/* <a href=""><span className="learn-more">Learn more →</span></a> */}
                    </div>
                  </div>
                </div>
              ))}
            </div>

          </div>
        </div>
      </section>






      {/* Image Slider Section */}
      <section className="logo-slider">
        <div className="slider-track">
          {[story, m1, m2, m5, e1, e2, e3, yoga10, yoga3, yoga4, yoga5].map((img, index) => (
            <div className="slide" key={index}>
              <img
                src={img}
                alt="Yoga"
                onError={(e) => {
                  e.target.src = "https://images.unsplash.com/photo-1545205597-3d9d02c29597?auto=format&fit=crop&w=800&q=80";
                }}
              />
            </div>
          ))}
        </div>
      </section >



      {/* Testimonials Slider Section */}
      <TestimonialSlider />

      <section className="faq-section">
        <div className="container">
          <div className="section-header" data-aos="fade-up">
            <span className="section-tag">{t('home.faq.tag')}</span>
            <h2 className="section-title">{t('home.faq.title')} <span className="highlight">{t('home.faq.highlight')}</span></h2>
            <div className="divider"></div>
            <p className="section-subtitle">{t('home.faq.subtitle')}</p>
          </div>

          <div className="faq-container">
            {faqList.map((id, index) => (
              <div
                className={`faq-item ${faqOpenState[id] ? 'active' : ''}`}
                key={id}
                data-aos="fade-up"
                data-aos-delay={100 * (index % 3)}
              >
                <div
                  className="faq-question"
                  onClick={() => toggleFaq(id)}
                >
                  <h3>{t(`home.faq.${id}.q`)}</h3>
                  <span className="faq-toggle">{faqOpenState[id] ? '−' : '+'}</span>
                </div>
                <div className="faq-answer">
                  <p>{t(`home.faq.${id}.a`)}</p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>
      {/* <button 
        onClick={() => window.scrollTo({ top: 0, behavior: 'smooth' })} 
        className={`back-to-top ${isVisible ? 'visible' : ''}`}
        aria-label="Back to top"
        title="Back to Top"
      >
        <i className="fas fa-arrow-up"></i>
        <span className="back-to-top-text"><svg width="20" height="20" viewBox="0 0 24 24" fill="none">
          <path d="M12 4L5 11H9V20H15V11H19L12 4Z" fill="white"/>
        </svg></span>
      </button> */}
    </div >
  );
}

export default Home;
